import { ApiList } from "../../Config/ApiList";

// Shared art resolution for the Closet screens (TryOnStage, ClosetManager).
// Mirrors the app's TiwiArt: server-hosted image when the catalog row has
// one (admin-uploaded), bundled asset by asset_key otherwise (launch items,
// copied from the app bundle into src/Assets/tiwi).

const bundledCtx = require.context("../../Assets/tiwi", false, /\.png$/);
export const BUNDLED = Object.fromEntries(
  bundledCtx.keys().map((k) => [k.replace("./", "").replace(".png", ""), bundledCtx(k)])
);

const thumbCtx = require.context("../../Assets/tiwi/thumbs", false, /\.png$/);
export const BUNDLED_THUMBS = Object.fromEntries(
  thumbCtx.keys().map((k) => [k.replace("./", "").replace(".png", ""), thumbCtx(k)])
);

export const layerUrl = (item) => {
  if (!item) return null;
  if (item.layer_image) return `${ApiList.IMG_URL}${item.layer_image}`;
  return BUNDLED[item.asset_key] || null;
};

export const thumbUrl = (item) => {
  if (!item) return null;
  if (item.thumb_image) return `${ApiList.IMG_URL}${item.thumb_image}`;
  return BUNDLED_THUMBS[item.asset_key] || BUNDLED[item.asset_key] || null;
};
